export const CustomTreeName = 'CustomTreeComponent';
